import React from 'react';
import classNames from 'classnames';
import { useSelector, useDispatch } from 'react-redux';
import { useFeature } from '@growthbook/growthbook-react';
import Local from '../Local/Local';
import { setViewedBonusesWelcome } from '../../redux/actions/app/storage';
import {
  userNumberSelector,
  isLoggedInSelector,
} from '../../redux/reducers/app/params';
import { isViewedBonusesWelcomeSelector } from '../../redux/reducers/app/storage';
import { getDataTestAttrs } from '../../utils/testing-locators';
import { NAMESPACES } from '../../constants/namespaces';
import { FEATURES } from '../../constants/featureToggling';
import {
  WELCOME_BONUS_OVERLAY,
  WELCOME_BONUS_DIALOG,
} from '../../constants/dataTestIds';
import styles from './BonusesWelcome.module.css';

const BonusesWelcome = ({ className = '' }) => {
  const isEnabledBonusPopup = useFeature(FEATURES.SHOW_BONUS_POPUP).on;

  const dispatch = useDispatch();
  const isLoggedIn = useSelector(isLoggedInSelector);
  const userNumber = useSelector(userNumberSelector);
  const isViewedMessage = useSelector(isViewedBonusesWelcomeSelector);

  return isEnabledBonusPopup && isLoggedIn && !isViewedMessage ? (
    <div
      onClick={() => dispatch(setViewedBonusesWelcome(userNumber))}
      className={classNames(styles.overlay, className)}
      {...getDataTestAttrs(WELCOME_BONUS_OVERLAY)}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className={styles.dialog}
        {...getDataTestAttrs(WELCOME_BONUS_DIALOG)}
      >
        <span className={styles.title}>
          <i
            className={styles.icon}
            style={{
              backgroundImage: `url(${require('../../assets/emoji/fire.png')})`,
            }}
          />
          <Local namespace={NAMESPACES.BONUS}>Bonuses live here now!</Local>
        </span>
      </div>
    </div>
  ) : null;
};

export default BonusesWelcome;
